export const manifestTypeConstants = {
    NCC: 3,
    VIPR: 4,
    DCR: 5,
    PROJECT:6,
    ODF: 7,
    TYPE2: 8
};
